let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9xAGT")).then(() => parcelRequire('afglw'));